export default __webpack_public_path__ + "static/media/ic_mini_eximbank.65c5bbeb.svg";